module.exports = __webpack_public_path__ + "assets/img/14.335172ab.png";